import { isNumber } from 'lodash-es';
/**
 * @example
 * input: 0.1
 * output: '10%'
 * @example
 * input: 0.15
 * output: '15%'
 * @example
 * input: null
 * output: ''
 */
export const getParsedPlatformFeePercentage = ({ platformFeePercentage, }) => {
    if (!isNumber(platformFeePercentage))
        return '';
    const parsedPlatformFeePercentage = `${Math.round(platformFeePercentage * 100)}%`;
    return parsedPlatformFeePercentage;
};
